export function formatNewsDate(str) {
  str = UTCtoBeiJing(str)
  let _date = new Date(str)
  let _month = _date.getMonth() + 1
  let _day = parseInt(_date.getDate()) >= 10 ? _date.getDate() : ('0' + _date.getDate())
  return _month + '-' + _day
}
export function formatJobfairDate(str) {
  str = UTCtoBeiJing(str)
  var _date = new Date(str)
  var _month = (_date.getMonth() + 1) >= 10 ? (_date.getMonth() + 1) : '0' + (_date.getMonth() + 1)
  var _day = parseInt(_date.getDate()) >= 10 ? _date.getDate() : ('0' + _date.getDate())
  return _date.getFullYear() + '-' + _month + '-' + _day
}
export function formatNewsListDate(str) {
  str = UTCtoBeiJing(str)
  var _date = new Date(str)
  return (
    _date.getFullYear() +
    '年' +
    (_date.getMonth() + 1) +
    '月' +
    _date.getDate() +
    '日'
  )
}
export function UTCtoBeiJing(str) {
  if (!str) {
    return str
  }
  str = new Date(str)
  const year = str.getUTCFullYear()
  const month = (str.getUTCMonth() + 1) >= 10 ? (str.getUTCMonth() + 1) : ('0' + (str.getUTCMonth() + 1))
  const date = str.getUTCDate() >= 10 ? str.getUTCDate() : ('0' + str.getUTCDate())
  let hours = str.getUTCHours() >= 10 ? str.getUTCHours() : ('0' + str.getUTCHours())
  const minutes = str.getUTCMinutes() >= 10 ? str.getUTCMinutes() : ('0' + str.getUTCMinutes())
  const seconds = str.getUTCSeconds() >= 10 ? str.getUTCSeconds() : ('0' + str.getUTCSeconds())
  return year + '/' + month + '/' + date + ' ' + hours + ':' + minutes + ':' + seconds
}



// WEBPACK FOOTER //
// ./src/utils/formatter.js